export default __webpack_public_path__ + "static/media/svn bank.a483d696.png";